// extracted by mini-css-extract-plugin
module.exports = {"slider":"SliderContainer_slider__HdDBq","dots":"SliderContainer_dots__B_LNy","buttons":"SliderContainer_buttons__Iwp4Y"};